module.exports = __webpack_public_path__ + "static/media/abstract1.74469765.jpg";